(function () {
  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
  ].join(',');

  var CAROUSEL_SELECTOR = [
    '[data-flickity]',
    '.flickity-enabled',
    '.flickity-carousel',
    '.collections_tag_slider',
    '.colorSwitchMetafield',
    '.recommendations_slider',
    '#complementary-slider'
  ].join(',');

  var VIEWPORT_AWARE_CAROUSEL_SELECTOR = [
    '.collection-tabs .flickity-carousel',
    '.recommendations_slider',
    '#complementary-slider'
  ].join(',');
  var ORIGINAL_TABINDEX_ATTR = 'data-carousel-original-tabindex';
  var ORIGINAL_TABINDEX_NONE = '__none__';
  var refreshTimeout;

  function getCarouselCells(carousel) {
    var flickityCells = carousel.querySelectorAll('.flickity-slider > *');
    if (flickityCells.length) return flickityCells;

    return carousel.querySelectorAll('.carousel-cell, .collections_tag_item');
  }

  function setFocusableState(element, isHidden) {
    if (isHidden) {
      if (!element.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
        element.setAttribute(
          ORIGINAL_TABINDEX_ATTR,
          element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : ORIGINAL_TABINDEX_NONE
        );
      }

      element.setAttribute('tabindex', '-1');
      return;
    }

    if (!element.hasAttribute(ORIGINAL_TABINDEX_ATTR)) return;

    var originalTabindex = element.getAttribute(ORIGINAL_TABINDEX_ATTR);
    if (originalTabindex === ORIGINAL_TABINDEX_NONE) {
      element.removeAttribute('tabindex');
    } else {
      element.setAttribute('tabindex', originalTabindex);
    }

    element.removeAttribute(ORIGINAL_TABINDEX_ATTR);
  }

  function isViewportAwareCarousel(carousel) {
    return carousel.matches && carousel.matches(VIEWPORT_AWARE_CAROUSEL_SELECTOR);
  }

  function isCellVisibleInViewport(cell, carousel) {
    var viewport = carousel.querySelector('.flickity-viewport');
    if (!viewport) return cell.getAttribute('aria-hidden') !== 'true';

    var cellRect = cell.getBoundingClientRect();
    var viewportRect = viewport.getBoundingClientRect();
    var tolerance = 1;

    return cellRect.right > viewportRect.left + tolerance &&
      cellRect.left < viewportRect.right - tolerance &&
      cellRect.bottom > viewportRect.top + tolerance &&
      cellRect.top < viewportRect.bottom - tolerance;
  }

  function setCellHiddenState(cell, isHidden) {
    if (isHidden) {
      if (cell.getAttribute('aria-hidden') !== 'true') {
        cell.setAttribute('aria-hidden', 'true');
      }
    } else if (cell.hasAttribute('aria-hidden')) {
      cell.removeAttribute('aria-hidden');
    }

    if ('inert' in cell) {
      cell.inert = isHidden;
    }
  }

  function getCarousels(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(CAROUSEL_SELECTOR)) {
      return [scope];
    }

    if (!scope.querySelectorAll) {
      return [];
    }

    return Array.prototype.slice.call(scope.querySelectorAll(CAROUSEL_SELECTOR));
  }

  window.updateCarouselAccessibility = function updateCarouselAccessibility(root) {
    getCarousels(root).forEach(function (carousel) {
      Array.prototype.forEach.call(getCarouselCells(carousel), function (cell) {
        var isHidden = isViewportAwareCarousel(carousel)
          ? !isCellVisibleInViewport(cell, carousel)
          : cell.getAttribute('aria-hidden') === 'true';

        setCellHiddenState(cell, isHidden);

        Array.prototype.forEach.call(cell.querySelectorAll(FOCUSABLE_SELECTOR), function (focusable) {
          setFocusableState(focusable, isHidden);
        });
      });
    });
  };

  function bindFlickityEvents(root) {
    getCarousels(root).forEach(function (carousel) {
      var flkty = window.Flickity && window.Flickity.data(carousel);

      if (carousel.hasAttribute('data-carousel-a11y-bound')) {
        window.updateCarouselAccessibility(carousel);
        return;
      }

      if (flkty) {
        carousel.setAttribute('data-carousel-a11y-bound', 'true');

        flkty.on('ready', function () {
          window.updateCarouselAccessibility(carousel);
        });
        flkty.on('change', function () {
          window.updateCarouselAccessibility(carousel);
        });
        flkty.on('select', function () {
          window.updateCarouselAccessibility(carousel);
        });
        flkty.on('settle', function () {
          window.updateCarouselAccessibility(carousel);
        });
        flkty.on('resize', function () {
          window.updateCarouselAccessibility(carousel);
        });
      }

      window.updateCarouselAccessibility(carousel);
    });
  }

  function refresh(root) {
    clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(function () {
      bindFlickityEvents(root || document);
      window.updateCarouselAccessibility(root || document);
    }, 0);
  }

  function debounce(fn, delay) {
    var timeout;

    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  function nodeTouchesCarousel(node) {
    if (!node || node.nodeType !== 1) return false;

    return (node.matches && (
      node.matches(CAROUSEL_SELECTOR) ||
      node.matches('.carousel-cell, .collections_tag_item')
    )) ||
      (node.closest && node.closest(CAROUSEL_SELECTOR)) ||
      (node.querySelector && node.querySelector(CAROUSEL_SELECTOR));
  }

  function mutationTouchesCarousel(mutation) {
    if (mutation.type === 'attributes') {
      return nodeTouchesCarousel(mutation.target);
    }

    return Array.prototype.some.call(mutation.addedNodes, nodeTouchesCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    refresh(document);
    setTimeout(function () {
      refresh(document);
    }, 300);

    if ('MutationObserver' in window && document.body) {
      var observer = new MutationObserver(function (mutations) {
        var shouldRefresh = mutations.some(mutationTouchesCarousel);

        if (shouldRefresh) {
          refresh(document);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });
    }
  });

  window.addEventListener('resize', debounce(function () {
    refresh(document);
  }, 150));

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  document.addEventListener('swym:collections-loaded', function () {
    refresh(document);
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.tab-button')) {
      refresh(document);
    }
  });
})();
